import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'crs-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.scss']
})
export class CoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
